module.exports = __webpack_public_path__ + "img/team-marie-tasche.74a49dea.jpg";